import type { Router } from 'vue-router'

export default (router: Router) => {
  router.addRoute({
    path: '/register',
    name: 'RegisterPage',
    component: () => import('@/modules/register/views/RegisterPage.vue'),
    meta: {
      layout: 'LoginSplitLayout',
      requiresAuth: false,
    },
  })
}
